module.exports = __webpack_public_path__ + "images/emoji/hand.e862b3872a25f5fe6811.png";